import React, { Component } from "react";
import GoogleMapReact from "google-map-react";
import Geocode from "react-geocode";
import { connect } from "react-redux";
import {setLocationAction} from "../../redux/actions/action"
import _ from 'lodash';

//export default class GoogleMaps extends Component {
function GoogleMaps(props) {

    const onMarkerDragEnd = (coord, index) => {
        const { latLng } = coord;
        const lat = latLng.lat();
        const lng = latLng.lng();
        //console.log("coord, index ",coord, lat,lng)
        let data = {
            lat:lat,
            lng:lng,
            //address:"Punawale, Pimpri-Chinchwad, Maharashtra 411033, India  "
        }
        //props.setLocationAction(data)
        Geocode.setApiKey('AIzaSyC1i55hHwdQFdwU1BxXjJpaq7QVqqQjSMg')
        Geocode.fromLatLng(lat, lng).then(
            response => {
                try{
                    let address = _.find(response.results, function(o) {
                       return o.types.includes('postal_code') //o.types.includes('administrative_area_level_2')
                     });
                    //  console.log("address ",address,response.results)
                     if(address){
                        data["address"] = address.formatted_address
                        props.setLocationAction(data)
                     }
                   }catch(e){
                       console.log(e)
                   }
                // console.log("response ",response);
                // const data = {
                //     'value': value,
                //     'fieldId': fieldData.trackedEntityAttribute.id,
                //     'lat': lat,
                //     'lng': lng,
                // }
                // props.onGoogleLocationChange(data) 
            },
            error => {
                console.error(error);
            }
        );
      };

  const loadMap = (map, maps) => {
    const cityCircle = new window.google.maps.Circle({
    //   strokeColor: "#FF0000",
    //   strokeOpacity: 0.8,
    //   strokeWeight: 2,
    //   fillColor: "#FF0000",
    //   fillOpacity: 0.35,
      map,
      center: { lat: props.geoLat, lng: props.geoLng },
      //radius: 10000,
      draggable: true
    });


 let marker = new maps.Marker({
        position: { lat: props.geoLat, lng: props.geoLng  },
        map,
        draggable:true,
      });

      marker.addListener("dragend", (coord, index) => {
        onMarkerDragEnd(coord, index)
      });

  };
  
    // console.log("google map function");
    return (
        <div style={{ height: "400px", width: "100%" }}>
        <GoogleMapReact
            bootstrapURLKeys={{ key: "AIzaSyC1i55hHwdQFdwU1BxXjJpaq7QVqqQjSMg" }} //AIzaSyC1i55hHwdQFdwU1BxXjJpaq7QVqqQjSMg AIzaSyDQUCTfssG7Cbr1XQrjbKrSYxDe14rrzG8
            defaultCenter={{ lat: props.geoLat, lng: props.geoLng }}
            defaultZoom={10}
            yesIWantToUseGoogleMapApiInternals
            onGoogleApiLoaded={({ map, maps }) => loadMap(map, maps)}
        />
        </div>
    );
  
}

export default connect(null, {setLocationAction})(GoogleMaps);